module.exports = __webpack_public_path__ + "media/images/logo_novum_slogan_white-cc615b6272245ab27a5ffe69b5c47486.png";